import { Box, Typography } from "@mui/material";
import { SessionContainer, SessionLogo } from "empower-energy-owner-components";

const styles = () => {
  return {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 9999,
    backgroundColor: "white",
  };
};

const Maintenance = () => {
  return (
    <Box sx={styles}>
      <SessionContainer>
        <Box px={2} className="flex-col items-justify-center" padding="30px">
          <Typography variant="h3" textAlign="center" marginBottom="20px">
            Scheduled Maintenance
          </Typography>
          <Typography variant="h6" textAlign="center" marginBottom="20px">
            The Empower fleet dashboard is temporarily unavailable.
          </Typography>
          <Typography variant="h6" textAlign="center" marginBottom="20px">
            If you have any concerns, please reach out to us at{" "}
            <a href="mailto://support@elektrobank.com.au">
              support@elektrobank.com.au
            </a>
          </Typography>

          <Box my={3} className="items-justify-center">
            <SessionLogo />
          </Box>
        </Box>
      </SessionContainer>
    </Box>
  );
};

export default Maintenance;
